import { FuelType, Vehicle } from "../../../models";
import { VehicleForm } from "../TriplePInterface";

export interface VehiclePayload {
  data: {
    type: string;
    attributes: {
      label: string;
      fuel_type: FuelType;
      mpg: number | null;
    };
  };
}

export const toVehicle = (form: VehicleForm): VehiclePayload => {
  return {
    data: {
      type: "vehicles",
      attributes: {
        label: form.label,
        fuel_type: form.fuelType,
        mpg: form.mpg ?? null,
      },
    },
  };
};

export interface UpdateVehiclePayload {
  data: {
    id: string;
    type: string;
    attributes: {
      label: string;
      // The backend PUT /vehicles/{id} is a FULL-COLUMN REPLACE (gorp
      // UpdateColumns): any persisted attribute we omit is written back as NULL.
      // So we must echo every persisted field — otherwise editing the label
      // would wipe the Samsara link and identity columns. Genuinely-null fields
      // are sent as null (a no-op that preserves the existing NULL).
      samsara_vehicle_id: string | null;
      vin: string | null;
      make: string | null;
      model: string | null;
      model_year: number | null;
      license_plate: string | null;
      fuel_type: FuelType;
      mpg: number | null;
    };
  };
}

export const toUpdateVehicle = (vehicle: Vehicle): UpdateVehiclePayload => {
  return {
    data: {
      id: vehicle.id,
      type: "vehicles",
      attributes: {
        label: vehicle.label,
        samsara_vehicle_id: vehicle.samsaraVehicleId ?? null,
        vin: vehicle.vin ?? null,
        make: vehicle.make ?? null,
        model: vehicle.model ?? null,
        model_year: vehicle.modelYear ?? null,
        license_plate: vehicle.licensePlate ?? null,
        fuel_type: vehicle.fuelType,
        mpg: vehicle.mpg ?? null,
      },
    },
  };
};
